import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Signup() {
  const { signup } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const onSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 8) {
      toast.error("Password must be at least 8 characters.");
      return;
    }
    setLoading(true);
    try {
      await signup(form.email, form.password, form.name);
      toast.success("Account created.");
      navigate("/submissions");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Signup failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <Header />
      <div className="rgu-container py-20 grid grid-cols-1 md:grid-cols-12 gap-12 max-w-4xl">
        <div className="md:col-span-5">
          <div className="rgu-eyebrow text-slate-500 mb-3">Account · Create</div>
          <h1 className="font-display text-3xl md:text-4xl text-[#0A192F]">Open an RGU account.</h1>
          <p className="mt-4 text-slate-600">Submit items for authentication, track progress in your Submission Center, and access Letter of Opinion offers.</p>
        </div>
        <form onSubmit={onSubmit} className="md:col-span-7 border border-slate-200 p-8 space-y-5" data-testid="signup-form">
          <div>
            <Label htmlFor="name">Name</Label>
            <Input id="name" data-testid="signup-name" required value={form.name} onChange={(e) => set("name", e.target.value)} className="mt-2 rounded-none" />
          </div>
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" data-testid="signup-email" type="email" required value={form.email} onChange={(e) => set("email", e.target.value)} className="mt-2 rounded-none" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" data-testid="signup-password" type="password" required value={form.password} onChange={(e) => set("password", e.target.value)} className="mt-2 rounded-none" />
            <div className="text-xs text-slate-500 mt-1">Minimum 8 characters.</div>
          </div>
          <button type="submit" disabled={loading} className="rgu-btn-primary w-full justify-center text-xs uppercase tracking-widest" data-testid="signup-submit">
            {loading ? "Creating account…" : "Create account"}
          </button>
          <div className="text-sm text-slate-500 pt-2">
            Already have an account? <Link to="/login" className="text-[#0A192F] underline" data-testid="signup-login-link">Sign in</Link>
          </div>
        </form>
      </div>
      <Footer />
    </div>
  );
}
